module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/corner-vacant-property/corner-vacant-property.component.css
// module id = ./src/app/reports/corner-vacant-property/corner-vacant-property.component.css
// module chunks = main